import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sensorAiByInstPointKey } from '@pages/SensorDetails/services/useSensorAiByInstPointQuery';

import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';
import { listByInstPointKey } from '@services/useListByInstPointQuery';
import { hardwareOverviewEquipmentItemKey } from '@pages/EquipmentDetails/services/useHardwareOverviewEquipmentItemQuery';

const sevCreateFn = (data) => apiClient.post(`${APP_API_URL_V2}fsd/action-item/sev`, data);

export const useSevCreateMutation = (props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sevCreateFn,
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [listByInstPointKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [sensorAiByInstPointKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewEquipmentItemKey()[0]] });
      props?.onSuccess && props.onSuccess(data);
    },
  });
};
